import React, { Fragment, useContext, useEffect } from "react";
import Scaler from "../dash/components/scaler/Scaler";
import DashLayout from '../dash/DashPage';
import styles from "./styles";
import propTypes from "prop-types";
import { SessionContext } from "../../utility/useSession";
import AnimateFrom from "../../components/animations/AnimateFrom";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";

const NotFoundPage: React.FunctionComponent<{
    title?: string;
    message?: string;
    wrapWithDash?: boolean;
}> = (props) => {

    const session = useContext(SessionContext);
    const history = useHistory();
    const { t } = useTranslation();

    useEffect(() => {
        if (session.current.site == null || session.current.site.user == null) {
            history.replace("/");
        }
    });

    const wrapWithDash = props.wrapWithDash == null ? session.current.site != null : props.wrapWithDash == true;

    const err = (<div>
        <Scaler>
            <div style={styles.bg}>
                <div style={styles.centeredBox}>
                    <div style={styles.centeredBoxInner}>
                        <AnimateFrom delay={0.5} style={{
                            opacity: 0,
                            zoom: 0,
                        }}>
                            <span style={styles.title}>{props.title || t("errors.pageNotFound.title")}</span>
                        </AnimateFrom>
                        <AnimateFrom delay={0.5} style={{
                            opacity: 0,
                            y: -50,
                            zoom: 0
                        }}>
                            <span style={styles.message}>{props.message || t("errors.pageNotFound.message")}</span>
                        </AnimateFrom>


                    </div>
                </div>
            </div>
        </Scaler>
    </div>);

    if (wrapWithDash != true) {
        return <Fragment>
            {err}
        </Fragment>;
    }

    return (<DashLayout absoluteChildren={<Fragment>{err}</Fragment>}></DashLayout>);
};

NotFoundPage.propTypes = {
    title: propTypes.string,
    message: propTypes.string,
    wrapWithDash: propTypes.bool
}

export default NotFoundPage;
